import React, { useContext } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Field, getFormValues } from 'redux-form';
import RenderSwitchComponent from './SwitchPanel';
import { BTN_FACTORY_V3_FORM } from '../../clientConstants';
import { Context as WorldReadyContext } from '@paypalcorp/worldready-react';
import { MessageFormat } from '@paypalcorp/worldready';

const RecurringSwitch = ({ formValues }) => {
  const worldReady = useContext(WorldReadyContext);

  return (
    <Field
      id="recurringEnabled"
      name="recurringEnabled"
      label="recurringEnabled"
      title={new MessageFormat(worldReady, {
        id: 'buttonsV3.switches.recurringRadio.label',
      }).format()}
      component={RenderSwitchComponent}
      isChecked={formValues.recurringEnabled === 'yes'}
    />
  );
};

const mapStateToProps = (state) => {
  const { application = {}, buttonFactoryV3 = {} } = state;

  return {
    application,
    buttonFactoryV3,
    formValues: getFormValues(BTN_FACTORY_V3_FORM)(state),
    initialValues: buttonFactoryV3.formattedButton,
  };
};

RecurringSwitch.propTypes = {
  formValues: PropTypes.object,
};

export default connect(mapStateToProps)(RecurringSwitch);
